import { getCookie } from '../hooks/use-cookie';

import { getVariables } from './get-functions';

const getStorage = () => {
  const {
    storageKey,
    customerUserIdKey,
    welcomeBonusKey,
    downTimeKey,
    affiliatesKey,
    regConfirmKey,
    firstDepositConfirmKey,
    themeKey,
    liveChatKey,
    languageKey,
    activeLinkKey,
    loginPopupKey,
    exitPopupKey,
    optionsKey,
    notificationKey,
    firstVisitKey,
    googleAnalyticsKey,
    pageHistoryKey,
  } = getVariables();

  // cookies
  const ga = getCookie(googleAnalyticsKey);
  const firstVisit = getCookie(firstVisitKey);

  // local storage
  const wb = localStorage.getItem(welcomeBonusKey);
  const cui = localStorage.getItem(customerUserIdKey);
  const downTime = localStorage.getItem(downTimeKey);
  const theme = localStorage.getItem(themeKey);
  const language = localStorage.getItem(languageKey);
  const liveChat = localStorage.getItem(liveChatKey);
  const activeLink = localStorage.getItem(activeLinkKey);
  const loginPopup = localStorage.getItem(loginPopupKey);
  const exitPopup = localStorage.getItem(exitPopupKey);
  const regConfirm = localStorage.getItem(regConfirmKey);
  const ftdConfirm = localStorage.getItem(firstDepositConfirmKey);
  const options = localStorage.getItem(optionsKey);
  const authKey = localStorage.getItem(storageKey);
  const notification = localStorage.getItem(notificationKey);
  const affiliates = localStorage.getItem(affiliatesKey);
  const pageHistory = localStorage.getItem(pageHistoryKey);

  return {
    ga,
    firstVisit,
    wb,
    cui,
    theme,
    language,
    liveChat,
    downTime,
    activeLink,
    loginPopup,
    exitPopup,
    regConfirm,
    ftdConfirm,
    options,
    authKey,
    notification,
    affiliates,
    pageHistory,
  };
};

export default getStorage;
